<template>
  <!--用户个人信息对话框-->
  <el-dialog width="560px" title="个人信息" :visible.sync="dialogFormVisible" top="8vh" destroy-on-close append-to-body>
    <el-form :model="form" style="width: 500px" status-icon ref="form" :rules="rule" label-width="80px" size="medium">
      <div class="formBox">
        <el-form-item label="姓名" prop="acc_name" style="width: 500px">
          <el-input v-model="form.acc_name" autocomplete="off" maxlength="31"></el-input>
        </el-form-item>
        <el-form-item label="账号" style="width: 500px">
          <el-input v-model="form.account" autocomplete="off" readonly></el-input>
        </el-form-item>
        <el-form-item label="身份证" style="width: 500px">
          <el-input v-model="form.idCard" type="password" autocomplete="off" readonly show-password></el-input>
        </el-form-item>
        <div class="RowBox">
          <el-form-item label="性别" style="width: 250px">
            <div class="TotheLeft">
              <el-select v-model="form.gender">
                <el-option key="男" value="男" label="男"></el-option>
                <el-option key="女" value="女" label="女"></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="学历" style="width: 250px">
            <div class="TotheLeft">
              <el-select v-model="form.education">
                <el-option key="无" value="无" label="无"></el-option>
                <el-option key="小学" value="小学" label="小学"></el-option>
                <el-option key="初中" value="初中" label="初中"></el-option>
                <el-option key="高中" value="高中" label="高中"></el-option>
                <el-option key="本科" value="本科" label="本科"></el-option>
                <el-option key="硕士" value="硕士" label="硕士"></el-option>
                <el-option key="博士" value="博士" label="博士"></el-option>
              </el-select>
            </div>
          </el-form-item>
        </div>
        <el-form-item label="岗位" prop="position" style="width: 500px">
          <el-input v-model="form.position" autocomplete="off" maxlength="30"></el-input>
        </el-form-item>
        <el-form-item label="入职时间" style="width: 500px">
          <div class="TotheLeft">
            <el-date-picker v-model="form.hire_date" type="date" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd"
              :clearable="false" :editable="false" :picker-options="{
                disabledDate(time) { // 设置禁用状态，参数为当前日期，要求返回 Boolean
                  return time.getTime() > Date.now();
                }
              }"></el-date-picker>
          </div>
        </el-form-item>

        <el-form-item label="离职时间" style="width: 500px">
          <div class="TotheLeft">
            <el-date-picker v-model="form.leave_date" type="date" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd"
              :clearable="false" :editable="false" :picker-options="{
                disabledDate(time) { // 设置禁用状态，参数为当前日期，要求返回 Boolean
                  return time.getTime() > Date.now();
                }
              }" placeholder="请选择离职日期"></el-date-picker>
          </div>
        </el-form-item>

        <el-form-item label="绩效计算" style="width: 500px">
          <el-select v-model="form.calculate_type" clearable placeholder="请选择绩效计算">
            <el-option v-for="item in optionsFormula" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="手机号码" prop="phonenumber" style="width: 500px">
          <el-input v-model="form.phonenumber" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注" style="width: 500px">
          <el-input type="textarea" v-model="form.note" autocomplete="off" maxlength="127" resize="none"></el-input>
        </el-form-item>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitForm" :loading="confirmLoading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "userInfo",
  data () {
    var isMobileNumber = (rule, value, callback) => {
      if (!(/^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/.test(value))) {
        callback(new Error("请输入正确的手机号！"));
      }
      else {
        callback();
      }
    };
    return {
      confirmLoading: false,
      dialogFormVisible: false,
      optionsFormula: [
        {
          value: '1',
          label: '默认'
        }, {
          value: '2',
          label: '其他'
        }
      ],
      form: {
        calculate_type: this.$store.state.userInfo.calculate_type,
        id: this.$store.state.userInfo.id,
        account: this.$store.state.userInfo.account,
        acc_name: this.$store.state.userInfo.acc_name,
        idCard: this.$store.state.userInfo.idCard,
        gender: this.$store.state.userInfo.gender,
        position: this.$store.state.userInfo.position,
        hire_date: this.$store.state.userInfo.hire_date,
        leave_date: this.$store.state.userInfo.leave_date,
        phonenumber: this.$store.state.userInfo.phonenumber,
        education: this.$store.state.userInfo.education === null ? "无" : this.$store.state.userInfo.education === 'NULL' ? "无" : this.$store.state.userInfo.education,
        note: this.$store.state.userInfo.note === null ? "" : this.$store.state.userInfo.note === 'NULL' ? "" : this.$store.state.userInfo.note
      },
      formLabelWidth: '50px',
      rule: {
        acc_name: [
          { required: true, message: "请输入姓名", trigger: 'change' }
        ],
        position: [
          { required: true, message: "请输入岗位", trigger: 'change' }
        ],
        phonenumber: [
          { required: true, message: '请输入手机号', trigger: 'change' },
          { validator: isMobileNumber, trigger: 'blur' }
        ],
      }
    }
  },

  methods: {
    init () {  //对话框初始化方法
      this.dialogFormVisible = true;
    },

    //验证信息并提交
    submitForm () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$confirm("是否确认修改个人信息", "提示", {
            type: "warning"
          }).then(() => {
            this.confirmLoading = true
            this.$axios.post("/users/updateById", this.form).then((res) => {
              if (res.data.code === 200) {
                this.$message.success("修改成功！");
                this.dialogFormVisible = false
                this.$store.commit("setUserInfo", res.data.data);
              }
              else {
                this.$message.error(res.data.msg);
              }
              this.confirmLoading = false
            }).catch((err) => {
              if (err.response.status === 500) {
                this.$message.error("网络异常，请稍后重试！");
              }
              else {
                this.$message.error("系统异常，请稍后重试！");
              }
              this.confirmLoading = false
            })
          }).catch(() => {
            this.$message.info("取消修改！");
          })
        }
        else {
          this.$message.error("请输入完整信息！");
        }
      })
    }
  }
}
</script>

<style scoped>
.formBox {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.RowBox {
  display: flex;
  flex-direction: row;
}

.TotheLeft {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
</style>
